import classNames from 'classnames';

import CustomStateLabel from '../../../common/custom-state-label';

import useStyles from './SearchRTStateLabel.styles';
import { GeoqueueRTSection } from '../../../../features/order/geoqueues';

function SearchRTStateLabel({ classes, isGeoqueue = false, ...props }) {
  const componentClasses = useStyles();

  if (isGeoqueue) {
    return <GeoqueueRTSection showStatusAction />;
  }

  return (
    <CustomStateLabel
      classes={{
        root: classNames(componentClasses.root, classes.root),
        iconRoot: classNames(componentClasses.iconRoot, classes.iconRoot),
      }}
      {...props}
    />
  );
}

export default SearchRTStateLabel;
